import React from 'react'
import EyeOffIcon from '../../elements/icons/EyeOffIcon'
import TextIcon from '../../elements/icons/TextIcon'
import VideoIcon from '../../elements/icons/VideoIcon'
import AudioIcon from '../../elements/icons/AudioIcon'

const DownloadableCardMinified = ({downloadable}) => {
  return (
    <div className='w-full flex items-center justify-between gap-x-[10px]'>
        <div className='w-[50px]'>
            <div className='w-[50px] bg-gray-50 flex items-center justify-center relative h-[50px] rounded-[8px]'
                style={{
                    backgroundImage: downloadable.documentType === 'IMAGE' ? `url(${downloadable.documentUrl})` : '',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }} 
            >
                {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-4 h-4 text-gray-500`} />}
                {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-4 h-4 text-gray-500`} />}
                {/* {downloadable.documentType === 'IMAGE' && <PhotoIcon className={`w-8 h-8 text-gray-500`} />} */}
                {(downloadable.documentType === 'TEXT' || downloadable.documentType === 'DOCUMENT')  && <TextIcon className={`w-4 h-4 text-gray-500`} />}
                {downloadable.hidden && <span className='rounded p-1 bg-yellow-200 bg-opacity-50 text-yellow-900 text-xs font-[500] font-sofia-pro'><EyeOffIcon className='w-4 h-4' /></span>}
            </div>
        </div>

        <div className="w-full">
            <p className='text-[14px] leading-[14px] font-[550] mb-[3px]'>{downloadable.name}</p>
            <p className='text-[12px]'>{downloadable.description.substr(0, 75)}{downloadable.description.length > 75 && '...'}</p>
        </div>
    </div>
  )
}

export default DownloadableCardMinified